import { addDays } from 'date-fns';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { TodayOrFutureDate } from '~/common/zod/date';

export const intakeRequestLineItemSchema = z.object({
  commodityGroupId: z.string().min(1),
  sequence: z.number(),
  description: z.string().nullable(),
  earlyDeliveryAt: TodayOrFutureDate.nullable(),
  quantity: z.number().positive(),
  expectedPricePerUnit: z.number().min(0).nullable(),
  id: z.string().nullable(),
  lateDeliveryAt: TodayOrFutureDate,
  position: z.string().min(1),
  title: z.string().min(1),
  unitId: z.string().min(1),
});
export type IntakeRequestLineItem = z.infer<typeof intakeRequestLineItemSchema>;

export const intakeRequestLineItemArraySchema = z.array(intakeRequestLineItemSchema).min(1);

const intakeRequestLineItemsSchema = z.object({
  lineItems: intakeRequestLineItemArraySchema,
});
export type IntakeRequestLineItems = z.infer<typeof intakeRequestLineItemsSchema>;

export const intakeRequestSchema = intakeRequestLineItemsSchema.extend({
  id: z.string().nullable(),
});

export type IntakeRequestFormData = z.infer<typeof intakeRequestSchema>;

export const lineItemDefault: DefaultValues<IntakeRequestLineItem> = {
  id: '',
  position: '',
  title: '',
  description: '',
  commodityGroupId: '',
  quantity: 0,
  expectedPricePerUnit: 0,
  earlyDeliveryAt: null,
  lateDeliveryAt: addDays(new Date(), 17),
};
